import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { DiscussionListConfig, TagService, UserService } from "../../../shared";

@Component({
  selector: "discussion-feed",
  templateUrl: "./discussion-feed.component.html",
  styleUrls: [
    "./discussion-feed.component.scss",
    "../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class DiscussionFeedComponent implements OnInit {
  public discussionSearchTerm: string = "";
  public discussionSearchField: FormGroup;
  public isAuthenticated: boolean;
  public config: DiscussionListConfig = new DiscussionListConfig();
  public tags: Array<string> = [];
  public tagsLoaded: boolean = false;

  constructor(
    private router: Router,
    private tagService: TagService,
    private userService: UserService,
    private fb: FormBuilder
  ) {
    this.initializeSearchField();
  }

  ngOnInit() {
    this.userService.isAuthenticated.subscribe((authenticated) => {
      this.isAuthenticated = authenticated;

      if (authenticated) {
        this.setListTo("AllDiscussionsFollowFeed");
      } else {
        this.setListTo("AllDiscussionsLatestFeed");
      }
    });

    this.tagService.getDiscussionsTags().subscribe((tags) => {
      this.tags = tags;
      this.tagsLoaded = true;
    });
  }

  public initializeSearchField() {
    this.discussionSearchField = this.fb.group({ term: "" });
    this.discussionSearchField.valueChanges.subscribe((value) => {
      if (value.term === "") {
        this.discussionSearchTerm = null;
        this.setListTo("AllDiscussionsLatestFeed");
      } else {
        this.discussionSearchTerm = value.term;
        this.setListTo("AllDiscussionsSearchFeed", {
          term: this.discussionSearchTerm,
        });
      }
    });
  }

  public setListTo(type: string = "", filters: Object = {}) {
    if (
      type === "AllDiscussionsLatestFeed" ||
      type === "AllDiscussionsFollowFeed"
    ) {
      this.clearSearchTerm();
    }
    // If followFeed is requested but user is not authenticated, redirect to login
    if (type === "AllDiscussionsFollowFeed" && !this.isAuthenticated) {
      this.router.navigateByUrl("/login");
      return;
    }
    // Otherwise, set the list object
    this.config = { type: type, filters: filters };
  }

  public setTagFeed(tag: string) {
    this.clearSearchTerm();
    this.setListTo("AllDiscussionsLatestFeed", { tag: tag });
  }

  public clearSearchTerm() {
    this.discussionSearchField.setValue({ term: null });
    this.discussionSearchTerm = null;
  }
}
